import { render, staticRenderFns } from "./UpcomingAuctions.vue?vue&type=template&id=f93c7fc2&scoped=true"
import script from "./UpcomingAuctions.vue?vue&type=script&lang=js"
export * from "./UpcomingAuctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93c7fc2",
  null
  
)

export default component.exports